// Resolve image URL handling absolute, relative (uploads), and fallback
export function resolveImageUrl(url) {
	if (!url) return '';
	// Normalize backslashes and collapse duplicate slashes early
	url = url.replace(/\\/g, '/').replace(/\/+/g, '/');
	// Remove accidental repeated uploads/products prefixes
	url = url.replace(/(\/uploads\/products\/){2,}/i, '/uploads/products/');
	// Already absolute (http/https or data URI)
	if (/^(https?:)?\/\//i.test(url) || /^data:/i.test(url)) return url;
	// If it starts with /uploads we assume same host
	if (url.startsWith('/uploads')) {
		const base = process.env.REACT_APP_PUBLIC_URL || '';
		return base ? base.replace(/\/$/, '') + url : url;
	}
	// Otherwise treat as relative path under /uploads/products
	const base = process.env.REACT_APP_PUBLIC_URL || '';
	return `${base ? base.replace(/\/$/, '') : ''}/uploads/products/${url}`;
}

export function sanitizeImages(images) {
	if (!Array.isArray(images)) return [];
	return images.filter(i => i && typeof i === 'object' && i.url && i.url.trim());
}
